<template>
  <div class="row">
    <user-menu></user-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_USER_ADMIN')">
      <form @submit.prevent="submit" autocomplete="off">
        <div class="form-group">
          <label for="departmentName">部署名</label>
          <input type="text" class="form-control" id="departmentName" placeholder="例) 総務部" v-model="postData.departmentName" required>
        </div>
        <button type="button" class="btn btn-secondary m-2" @click="goDepartmentList">戻る</button>
        <input v-if="edit" type="submit" class="btn btn-primary" value="編集"/>
        <input v-else type="submit" class="btn btn-primary" value="登録"/>
      </form>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import DepartmentAPI from '../../../api/department-api'
import CommonAPI from '../../../api/common-api'
import UserMenu from './UserMenu.vue'

export default {
  name: "new-edit-department",
  components: {
    UserMenu
  },
  data() {
    return {
      edit: false,
      loginUser: {
        role: 'ROLE_USER'
      },
      postData: {
      }
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
      this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
      this.init()
      this.$root.$refs.loading.$data.show = false
    },
  },
  mounted () {
  },
  methods: {
    // 新規 or 更新の判定
    init () {
      const id = this.$route.params.id
      if (id) {
        this.edit = true
        this.getDepartment(id)
      }
    },
    // 部署取得
    getDepartment (id) {
      this.$root.$refs.loading.$data.show = true
      DepartmentAPI.get(id)
        .then(res => {
            this.postData = res
            this.$root.$refs.loading.$data.show = false
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    submit () {
      this.$root.$refs.loading.$data.show = true
      if (this.edit){
        // 編集
        DepartmentAPI.update(this.postData)
            .then(res => {
              this.goDepartmentList()
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      } else {
        // 新規登録
        DepartmentAPI.create(this.postData)
            .then(res => {
              this.goDepartmentList()
              this.$root.$refs.loading.$data.show = false
            })
            .catch(err => {
              console.error(err)
              this.$root.$refs.loading.$data.show = false
            })
      }
    },
    // 部署一覧へ
    goDepartmentList () {
        this.$router.push('/admin/department/top')
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
  },
  computed: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/user/DepartmentNewEdit.vue